module.exports = __webpack_public_path__ + "img/serverIcon.22dd9ade.png";